import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';

@Component({
  selector: 'app-bonus-points-config',
  templateUrl: './bonus-points-config.component.html',
  styleUrls: ['./bonus-points-config.component.scss']
})
export class BonusPointsConfigComponent implements OnInit {


  page:any = 1
  sendDetailsToChild:any = ''
  ComponentNo = 1
  bonus_points_list:any[] = []
  getPaginationCount:any
  filteredDetails: any = {
    name: '',
    month: '',
    year: ''
  }

  constructor(
    private modalService : NgbModal,
    private route : Router,
    private apiService : ApiService,
    private apiConfig : ApiConfiguration 
    ) { }

  ngOnInit() {
    this.getBonusPointsList()
  }

  filterListOfRecords(){
    this.getBonusPointsList()
  }

  Reset(){
    this.filteredDetails.name = '',
    this.filteredDetails.month= '',
    this.filteredDetails.year= ''
    this.getBonusPointsList()
  }
  paginationClick(event){
    this.page = event
    this.getBonusPointsList()
  }
  addBonusPointsConfig(){
    this.route.navigateByUrl("/hubAdmin/add-bonus-points")
  }

  rewards_images:any="";
  View(target,rewards_data){
    this.rewards_images=rewards_data;
    console.log(this.rewards_images,"rewards_images");
   this.modalService.open(target, 
    { size: 'lg',backdrop:true});
  }
  getBonusPointsList(){
    this.apiService.getHeaders(this.apiConfig.getBonusPointsConfig + `?program_id=1&page=${this.page}`)
    .subscribe((res:any)=>{
      console.log(res ,"getBonusPoints response")
      this.bonus_points_list = res.body.data
      this.getPaginationCount = res.headers.get('X-Pagination-Total-Count')
      
    })
  }

  dismissModal(){
    this.modalService.dismissAll()
  }

}
